<router-outlet></router-outlet>

<!-- NgxUiLoader -->
<ngx-ui-loader></ngx-ui-loader>
